<template>
  <div>
    <b-modal  @hide="hide" id="editGroupModal" size="xl" title="Yönetici Grubunu Düzenle" hide-footer @show="detail">
      <b-form @submit="onSubmit" >

        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Grup Adı">
              <b-input v-model="group_name" placeholder="Grup Adı Giriniz"></b-input>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-card-header>
              Yetkiler
            </b-card-header>
            <b-card>
              <b-card-body>
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group label="Yönetici Grupları">
                      <b-badge variant="primary" info @click="selectAll('adminGroups')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.adminGroups.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.adminGroups.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.adminGroups.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.adminGroups.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.adminGroups.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Yöneticiler">
                      <b-badge variant="primary" info @click="selectAll('admins')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.admins.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.admins.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.admins.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.admins.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.admins.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Siteler">
                      <b-badge variant="primary" info @click="selectAll('sites')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.sites.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.sites.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.sites.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.sites.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.sites.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Papara Hesapları">
                      <b-badge variant="primary" info @click="selectAll('banks')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.banks.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.banks.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.banks.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.banks.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.banks.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Mefete Hesapları">
                      <b-badge variant="primary" info @click="selectAll('mefeteAccounts')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.mefeteAccounts.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mefeteAccounts.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mefeteAccounts.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mefeteAccounts.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mefeteAccounts.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="PeP Hesapları">
                      <b-badge variant="primary" info @click="selectAll('pepAccounts')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.pepAccounts.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.pepAccounts.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.pepAccounts.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.pepAccounts.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.pepAccounts.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label=" Hesap Grupları">
                      <b-badge variant="primary" info @click="selectAll('bankAccountGroups')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.bankAccountGroups.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.bankAccountGroups.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.bankAccountGroups.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.bankAccountGroups.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.bankAccountGroups.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Mailler">
                      <b-badge variant="primary" info @click="selectAll('mails')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.mails.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mails.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mails.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mails.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.mails.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Hazır Cevaplar">
                      <b-badge variant="primary" info @click="selectAll('answers')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.answers.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.answers.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.answers.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.answers.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.answers.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Yatırımlar">
                      <b-badge variant="primary" info @click="selectAll('deposits')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.deposits.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.deposits.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.deposits.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.deposits.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.deposits.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group label="Para Çekimleri">
                      <b-badge variant="primary" info @click="selectAll('withdrawals')">Tümünü Seç</b-badge>
                      <b-form-checkbox
                          v-model="auth_links.withdrawals.list"
                          :key="options[0].value"
                          :value="options[0].value"
                          name="flavour-1"
                      >
                        {{options[0].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.withdrawals.detail"
                          :key="options[1].value"
                          name="flavour-1"
                      >
                        {{options[1].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.withdrawals.add"
                          :key="options[2].value"
                          name="flavour-1"
                      >
                        {{options[2].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.withdrawals.edit"
                          :key="options[3].value"
                          name="flavour-1"
                      >
                        {{options[3].text}}
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="auth_links.withdrawals.remove"
                          :key="options[4].value"
                          name="flavour-1"
                      >
                        {{options[4].text}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </div>

        </div>
        <hr>
        <div class="row">

        </div>
        <div class="d-flex justify-content-center" v-if="!loading">
          <b-button type="submit" variant="success" class=""> <i class="fas fa-check" /> Kaydet</b-button>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-button type="submit" variant="success" class="" disabled> <span>  <i class="fas fa-spinner fa-spin"></i></span> </b-button>
        </div>
      </b-form>




    </b-modal>
  </div>
</template>

<script>
import settingsService from "@/services/settingsService";

export default {
  name: "EditGroup",
  data() {
    return {
      group_name: '',
      auth_links: {
        banks: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        sites: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        mails: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        answers: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        deposits: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        adminGroups: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        bankAccountGroups: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        admins: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        mefeteAccounts: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        pepAccounts: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
        withdrawals: {
          add: false,
          remove: false,
          edit: false,
          detail: false,
          list: false
        },
      },
      options: [
        { text: "Listele", value: true },
        { text: "Detayları Gör", value: true },
        { text: "Ekle", value: true },
        { text: "Düzenle", value: true },
        { text: "Sil", value: true }
      ],
      loading: false,

    }
  },
  props: ['id'],
  methods: {
    hide() {
      this.group_name = ''
    },
    selectAll(val) {
      if(val === 'banks'){
        this.auth_links.banks.add = true
        this.auth_links.banks.edit = true
        this.auth_links.banks.detail = true
        this.auth_links.banks.list = true
        this.auth_links.banks.remove = true
      }
      if(val === 'sites'){
        this.auth_links.sites.add = true
        this.auth_links.sites.edit = true
        this.auth_links.sites.detail = true
        this.auth_links.sites.list = true
        this.auth_links.sites.remove = true
      }
      if(val === 'mails'){
        this.auth_links.mails.add = true
        this.auth_links.mails.edit = true
        this.auth_links.mails.detail = true
        this.auth_links.mails.list = true
        this.auth_links.mails.remove = true
      }
      if(val === 'answers'){
        this.auth_links.answers.add = true
        this.auth_links.answers.edit = true
        this.auth_links.answers.detail = true
        this.auth_links.answers.list = true
        this.auth_links.answers.remove = true
      }
      if(val === 'deposits'){
        this.auth_links.deposits.add = true
        this.auth_links.deposits.edit = true
        this.auth_links.deposits.detail = true
        this.auth_links.deposits.list = true
        this.auth_links.deposits.remove = true
      }
      if(val === 'adminGroups'){
        this.auth_links.adminGroups.add = true
        this.auth_links.adminGroups.edit = true
        this.auth_links.adminGroups.detail = true
        this.auth_links.adminGroups.list = true
        this.auth_links.adminGroups.remove = true
      }
      if(val === 'bankAccountGroups'){
        this.auth_links.bankAccountGroups.add = true
        this.auth_links.bankAccountGroups.edit = true
        this.auth_links.bankAccountGroups.detail = true
        this.auth_links.bankAccountGroups.list = true
        this.auth_links.bankAccountGroups.remove = true
      }
      if(val === 'admins'){
        this.auth_links.admins.add = true
        this.auth_links.admins.edit = true
        this.auth_links.admins.detail = true
        this.auth_links.admins.list = true
        this.auth_links.admins.remove = true
      }
      if(val === 'mefeteAccounts'){
        this.auth_links.mefeteAccounts.add = true
        this.auth_links.mefeteAccounts.edit = true
        this.auth_links.mefeteAccounts.detail = true
        this.auth_links.mefeteAccounts.list = true
        this.auth_links.mefeteAccounts.remove = true
      }
      if(val === 'pepAccounts'){
        this.auth_links.pepAccounts.add = true
        this.auth_links.pepAccounts.edit = true
        this.auth_links.pepAccounts.detail = true
        this.auth_links.pepAccounts.list = true
        this.auth_links.pepAccounts.remove = true
      }
      if(val === 'withdrawals'){
        this.auth_links.withdrawals.add = true
        this.auth_links.withdrawals.edit = true
        this.auth_links.withdrawals.detail = true
        this.auth_links.withdrawals.list = true
        this.auth_links.withdrawals.remove = true
      }
    },
    onSubmit(event) {
      event.preventDefault()
      this.loading = true
      settingsService.groupEdit({auth_links: this.auth_links, group_name: this.group_name, id: this.id})
          .then((res) => {
            this.loading = false
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Başarıyla Düzenlendi.', message: ''})
              this.$bvModal.hide('editGroupModal')
              this.$store.dispatch('getRefresh', {groups: true})
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    detail(){
      this.loading = true
      settingsService.groupDetail({id: this.id})
      .then((res) => {
        this.loading = false
        if(res.state){
          this.group_name = res.data[0].group_name
          this.auth_links.banks.add = res.data[0].details[0].add
          this.auth_links.banks.edit = res.data[0].details[0].edit
          this.auth_links.banks.detail = res.data[0].details[0].detail
          this.auth_links.banks.list = res.data[0].details[0].list
          this.auth_links.banks.remove = res.data[0].details[0].remove

          this.auth_links.sites.add = res.data[0].details[1].add
          this.auth_links.sites.edit = res.data[0].details[1].edit
          this.auth_links.sites.detail = res.data[0].details[1].detail
          this.auth_links.sites.list = res.data[0].details[1].list
          this.auth_links.sites.remove = res.data[0].details[1].remove

          this.auth_links.mails.add = res.data[0].details[2].add
          this.auth_links.mails.edit = res.data[0].details[2].edit
          this.auth_links.mails.detail = res.data[0].details[2].detail
          this.auth_links.mails.list = res.data[0].details[2].list
          this.auth_links.mails.remove = res.data[0].details[2].remove

          this.auth_links.answers.add = res.data[0].details[3].add
          this.auth_links.answers.edit = res.data[0].details[3].edit
          this.auth_links.answers.detail = res.data[0].details[3].detail
          this.auth_links.answers.list = res.data[0].details[3].list
          this.auth_links.answers.remove = res.data[0].details[3].remove

          this.auth_links.deposits.add = res.data[0].details[4].add
          this.auth_links.deposits.edit = res.data[0].details[4].edit
          this.auth_links.deposits.detail = res.data[0].details[4].detail
          this.auth_links.deposits.list = res.data[0].details[4].list
          this.auth_links.deposits.remove = res.data[0].details[4].remove

          this.auth_links.adminGroups.add = res.data[0].details[5].add
          this.auth_links.adminGroups.edit = res.data[0].details[5].edit
          this.auth_links.adminGroups.detail = res.data[0].details[5].detail
          this.auth_links.adminGroups.list = res.data[0].details[5].list
          this.auth_links.adminGroups.remove = res.data[0].details[5].remove

          this.auth_links.bankAccountGroups.add = res.data[0].details[6].add
          this.auth_links.bankAccountGroups.edit = res.data[0].details[6].edit
          this.auth_links.bankAccountGroups.detail = res.data[0].details[6].detail
          this.auth_links.bankAccountGroups.list = res.data[0].details[6].list
          this.auth_links.bankAccountGroups.remove = res.data[0].details[6].remove

          this.auth_links.admins.add = res.data[0].details[7].add
          this.auth_links.admins.edit = res.data[0].details[7].edit
          this.auth_links.admins.detail = res.data[0].details[7].detail
          this.auth_links.admins.list = res.data[0].details[7].list
          this.auth_links.admins.remove = res.data[0].details[7].remove

          this.auth_links.mefeteAccounts.add = res.data[0].details[8].add
          this.auth_links.mefeteAccounts.edit = res.data[0].details[8].edit
          this.auth_links.mefeteAccounts.detail = res.data[0].details[8].detail
          this.auth_links.mefeteAccounts.list = res.data[0].details[8].list
          this.auth_links.mefeteAccounts.remove = res.data[0].details[8].remove

          this.auth_links.pepAccounts.add = res.data[0].details[9].add
          this.auth_links.pepAccounts.edit = res.data[0].details[9].edit
          this.auth_links.pepAccounts.detail = res.data[0].details[9].detail
          this.auth_links.pepAccounts.list = res.data[0].details[9].list
          this.auth_links.pepAccounts.remove = res.data[0].details[9].remove

          this.auth_links.withdrawals.add = res.data[0].details[10].add
          this.auth_links.withdrawals.edit = res.data[0].details[10].edit
          this.auth_links.withdrawals.detail = res.data[0].details[10].detail
          this.auth_links.withdrawals.list = res.data[0].details[10].list
          this.auth_links.withdrawals.remove = res.data[0].details[10].remove

        }else{
          this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>